"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchManaBalance = void 0;
const ethers_1 = require("ethers");
const decentraland_transactions_1 = require("decentraland-transactions");
const eth_1 = require("../../../lib/eth");
function fetchManaBalance(chainId, address) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const provider = yield (0, eth_1.getNetworkProvider)(chainId);
            const contract = (0, decentraland_transactions_1.getContract)(decentraland_transactions_1.ContractName.MANAToken, chainId);
            const mana = new ethers_1.ethers.Contract(contract.address, contract.abi, new ethers_1.ethers.providers.Web3Provider(provider));
            const balance = yield mana.balanceOf(address);
            return parseFloat(ethers_1.ethers.utils.formatEther(balance));
        }
        catch (error) {
            return 0;
        }
    });
}
exports.fetchManaBalance = fetchManaBalance;
//# sourceMappingURL=fetchManaBalance.js.map